"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Property = void 0;
const models_1 = require("lincd/lib/models");
const Shape_1 = require("lincd/lib/shapes/Shape");
const rdfs_1 = require("lincd-rdfs/lib/ontologies/rdfs");
const rdf_1 = require("../ontologies/rdf");
const package_1 = require("../package");
const Prefix_1 = require("lincd/lib/utils/Prefix");
// import {Resource} from 'lincd-rdfs/lib/shapes/Resource';
let Property = class Property extends Shape_1.Shape {
    get comment() {
        return this.getOne(rdfs_1.rdfs.comment).value;
    }
    set comment(value) {
        this.overwrite(rdfs_1.rdfs.comment, new models_1.Literal(value));
    }
    get domain() {
        return this.getOne(rdfs_1.rdfs.domain);
    }
    set domain(value) {
        this.overwrite(rdfs_1.rdfs.domain, value);
    }
    get isDefinedBy() {
        return this.getOne(rdfs_1.rdfs.isDefinedBy);
    }
    set isDefinedBy(value) {
        this.overwrite(rdfs_1.rdfs.isDefinedBy, value);
    }
    /**
     * Gets the ontology node that defines this property
     * Uses isDefinedBy but also looks at the URI for known matches with prefixes as a fallback
     */
    get ontology() {
        let isDefinedBy = this.isDefinedBy;
        if (isDefinedBy) {
            return isDefinedBy;
        }
        let [ontologyURI] = Prefix_1.Prefix.findMatch(this.namedNode.uri);
        if (ontologyURI) {
            return models_1.NamedNode.getOrCreate(ontologyURI);
        }
    }
    set ontology(value) {
        this.isDefinedBy = value;
    }
    get range() {
        return this.getOne(rdfs_1.rdfs.range);
    }
    set range(value) {
        this.overwrite(rdfs_1.rdfs.range, value);
    }
};
// static type: NamedNode = rdf.Property;
Property.targetClass = rdf_1.rdf.Property;
Property = __decorate([
    package_1.linkedShape
    // export class Property extends Resource {
], Property);
exports.Property = Property;
//# sourceMappingURL=Property.js.map